<template>
  <div class="clock">
    <span v-show="time">UK time {{ time }}</span>
  </div>
</template>

<script>
const SECOND = 1000;
export default {
  data: () => ({
    time: null,
  }),
  mounted() {
    this.$options.timer = window.setTimeout(this.updateDateTime, SECOND);
  },
  beforeDestroy() {
    window.clearTimeout(this.$options.timer);
  },
  methods: {
    updateDateTime() {
      this.time = this.$moment().tz('Europe/London').format('hh:mm:ss A')
      this.$options.timer = window.setTimeout(this.updateDateTime, SECOND);
    },
  },
};
</script>
